/**
 * Timezone Module
 * Automatically detects and saves user timezone to cookie
 */

import { setCookie, getCookie } from '../utils/cookie.js';

export function initTimezone() {
	const COOKIE_NAME = 'wpcore_timezone';
	const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const savedTimezone = getCookie(COOKIE_NAME);

	// Only update cookie if it doesn't exist or is different
	if (currentTimezone !== savedTimezone) {
		setCookie(COOKIE_NAME, currentTimezone, 365); // Save for 1 year
	}
}
